module.exports = __webpack_public_path__ + "img/dollar-sign-solid.63fa626f.svg";